import compareVersions from 'compare-versions';

export const MIN_11_AGENT_VERSION = '11.1';

export function stripDevVersionComponent(version: string): string {
  return version.replace(/-.*/, '');
}

/**
 * Checks if the 11 agent is capable of delivery content.
 * @param version - the version to test.
 * @returns true if version is at or above 11.1
 */
export default function deliveryCapable(version: string | undefined): boolean {
  return (
    !!version &&
    compareVersions(stripDevVersionComponent(version), MIN_11_AGENT_VERSION) >=
      0
  );
}
